import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 410px;

  button {
    flex: 1;
    width: 50px;
    height: 40px;
    min-width: 50px;
    min-height: 40px;
    border-radius: 5px;
    border: 2px solid #e6effb;
    background-color: #ffffff;
    font-family: 'Sora', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #aeaeae;

    &:hover {
      color: #858585;
      border-color: #9ec1f0;
    }

    &.active {
      border-color: #329bfc;
      color: #101d40;
    }
  }

  @media only screen and (max-width: 530px) {
  }
`;
